'use client'
import cl from 'clsx'
import { useState } from 'react'
import { useRouter, useParams } from 'next/navigation'
import routes from '@/utils/routes'
import useAuthStore from '@/store/auth'
import useModalStore from '@/store/modalStore'
import Description from './description'
import Methodology from './methodology'
import Outcome from './outcome'
import styles from './styles.module.css'

export default function AstTool({ dict }) {
    const [tab, setTab] = useState(1)
    const router = useRouter()
    const params = useParams()
    const lang = params?.lang || 'en'
    const { isAuth } = useAuthStore()
    const { openLoginModal } = useModalStore()

    const d = dict.ast_tool
    const { description_menu, methodology_menu, outcome_menu } = dict.discover

    const handleStartClick = () => {
        if (isAuth) {
            router.push(`/${lang}${routes.ast_tool}`)
        } else {
            openLoginModal()
        }
    }

    return (
        <div className={styles.discover__text_content}>
            <div>
                <div className={styles.discover__text_content_title_wrapper}>
                    <h2
                        onClick={() => setTab(1)}
                        className={cl(
                            styles.discover__text_content_title_item,
                            tab === 1 && styles.selected,
                            tab !== 1 && styles.discover__text_content_title_inactive
                        )}
                    >
                        {description_menu}
                    </h2>
                    <h2
                        onClick={() => setTab(2)}
                        className={cl(
                            styles.discover__text_content_title_item,
                            tab === 2 && styles.selected,
                            tab !== 2 && styles.discover__text_content_title_inactive
                        )}
                    >
                        {methodology_menu}
                    </h2>
                    <h2
                        onClick={() => setTab(3)}
                        className={cl(
                            styles.discover__text_content_title_item,
                            tab === 3 && styles.selected,
                            tab !== 3 && styles.discover__text_content_title_inactive
                        )}
                    >
                        {outcome_menu}
                    </h2>
                </div>
                <div className={styles.discover__text_content_description}>
                    {tab === 1 && <Description dict={dict} />}
                    {tab === 2 && <Methodology dict={dict} />}
                    {tab === 3 && <Outcome dict={dict} />}
                </div>
            </div>
            <div className={styles.discover__btn_wrapper}>
                <button
                    onClick={handleStartClick}
                    className={styles.discover__btn}
                >
                    {d.description.btn_start}
                </button>
            </div>
        </div>
    )
}
